const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/parametrizacao-horas-a-pagar",
    name: "parametrizacao-horas-a-pagar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrizacaoHorasAPagar/ParametrizacaoHorasAPagarHome.vue"
      ),
  },
  {
    path: "/parametrizacao-horas-a-pagar/novo",
    name: "parametrizacao-horas-a-pagar-novo",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrizacaoHorasAPagar/ParametrizacaoHorasAPagarCad.vue"
      ),
  },
  {
    path: "/parametrizacao-horas-a-pagar/editar/:id",
    name: "parametrizacao-horas-a-pagar-editar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrizacaoHorasAPagar/ParametrizacaoHorasAPagarEdit.vue"
      ),
  },
];

export default routes;
